import { c as _c } from "react/compiler-runtime";
import { Select } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type TriggeredDropdownProps = {
  isShowingTriggered: boolean;
  onClick: (isTriggered: boolean) => void;
};
const TriggeredDropdown = t0 => {
  const $ = _c(21);
  const {
    isShowingTriggered,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.ruleSetResults.dropdown"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const t2 = isShowingTriggered ? "triggered" : "notTriggered";
  let t3;
  if ($[1] !== onClick) {
    t3 = value => onClick(value === "triggered");
    $[1] = onClick;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t) {
    t4 = t(_temp);
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = {
      value: "triggered",
      label: t4
    };
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t) {
    t6 = t(_temp2);
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = {
      value: "notTriggered",
      label: t6
    };
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5 || $[12] !== t7) {
    t8 = [t5, t7];
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t) {
    t9 = t(_temp3);
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t2 || $[17] !== t3 || $[18] !== t8 || $[19] !== t9) {
    t10 = <Select value={t2} onChange={t3} options={t8} aria-label={t9} />;
    $[16] = t2;
    $[17] = t3;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};
export default TriggeredDropdown;
function _temp($) {
  return $.triggered;
}
function _temp2($_0) {
  return $_0.notTriggered;
}
function _temp3($_1) {
  return $_1.ruleResultGroups;
}